// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sd-9";
export var arrowButtonContainer = "_sd-5";
export var arrowButtonIcon = "_sd-6";
export var carouselArrowButton = "_sd-2";
export var carouselElementContainer = "_sd-1";
export var currentSlide = "_sd-8";
export var left = "_sd-3";
export var otherSlide = "_sd-a";
export var productCarouselContainer = "_sd-0";
export var right = "_sd-4";
export var sliderOverflow = "_sd-7";